"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function CtaOneSection({ heading = "Does my eCommerce business qualify for 0% Hong Kong tax?" }: { heading?: string } = {}) {
  return (
    <section className="w-full py-[30px] md:py-[60px] px-4 ">
      
      <div className="w-full max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-[32px]">
        
        {/* IMAGE */}
        <div className="w-full lg:flex-1">
          <Image
            src="/tax-optimization/cta-one.webp"
            alt="CTA Image"
            width={800}
            height={600}
            className="w-full h-[240px] sm:h-[320px] lg:h-[400px] object-cover rounded-[16px]"
          />
        </div>

        {/* TEXT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium">
              Often yes. Example structure: store registered in Hong Kong,
              customers in US / UK / EU, suppliers outside Hong Kong,
              operations remote. This frequently qualifies as offshore. Each
              structure is reviewed individually during your strategy session.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}